import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentPath } from '@service-initiation/shared-data-access-flow-manager';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import { useBillingDetailsAtom } from '@service-initiation/tech-care-data-access-store';

import { ReactComponent as CreditCard } from '../assets/ICM_CreditCard.svg';
import { PrimaryText, VisitDetailsListItem } from '../components';

const TEXT = TranslationEntries.Repairs.Cart.VisitDetails;

export const PaymentMethodSummaryItem: FC = () => {
  const { t } = useTranslation();
  const [billingDetails] = useBillingDetailsAtom();
  const currentPath = useCurrentPath();

  const isBillingDetailsStateValid =
    !!billingDetails?.billingAddress && !!billingDetails.payment_intent_id;

  return (
    <VisitDetailsListItem
      active={
        currentPath === Route.BillingDetails || isBillingDetailsStateValid
      }
      iconSrc={<CreditCard />}
      linkTo="BillingDetails"
      title={t(TEXT.PaymentText)}
    >
      {isBillingDetailsStateValid && <PrimaryText>Credit Card</PrimaryText>}
    </VisitDetailsListItem>
  );
};
